import {ButtonGroupProps} from './types';
import styled from 'styled-components';

/**
 * Buttons must be direct children of ButtonGroup.
 * Renders square corners for buttons within the group.
 */

export const ButtonGroup = styled.div<ButtonGroupProps>`
  display: flex;
  flex-direction: column;
  gap: 1px;
  width: 100%;

  & > *:not(:only-child) {
    &:not(:first-child):not(:last-child) {
      border-radius: 0;
    }

    &:first-child {
      border-bottom-left-radius: 0;
      border-bottom-right-radius: 0;
    }

    &:last-child {
      border-top-left-radius: 0;
      border-top-right-radius: 0;
    }
  }
`;
